import CreateVoiceTemplateFlow from 'domains/campaigns/components/CreateVoiceTemplateFlow/CreateVoiceTemplateFlow';

const ContentVoiceBuilderPage = () => <CreateVoiceTemplateFlow />;

export default ContentVoiceBuilderPage;
